export default "__VITE_ASSET__CmLCaqTH__"